import { useState } from "react";

import { ActionButton, Dialog } from "@eisox/design-system";
import { ArrowRightIcon, UpdateIcon } from "@eisox/icons";
import { useMutation } from "@tanstack/react-query";

import { valveApi } from "~/api";
import { m } from "~/paraglide/messages";
import type { EnhancedValve } from "~/types/valve.type";

const NAME = "RelaunchLearningDialog";

interface RelaunchLearningDialogProps {
  buildingId: string;
  valve: EnhancedValve;
  children?: React.ReactNode;
}

const RelaunchLearningDialog: React.FC<RelaunchLearningDialogProps> = ({ buildingId, valve, children }) => {
  const [open, setOpen] = useState(false);

  const { mutate } = useMutation({
    mutationFn: () => valveApi.relaunchLearning(buildingId, valve.id),
    onSuccess: () => setOpen(false),
  });

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      {children && <Dialog.Trigger asChild>{children}</Dialog.Trigger>}
      <Dialog.Content
        title={m.relaunch_learning_title()}
        icon={<UpdateIcon />}
        className="w-[95%] min-[992px]:w-[60%] min-[1200px]:w-[50%] min-[1400px]:w-[35%]"
      >
        <p className="text-center whitespace-pre-line">{m.relaunch_learning_content({ mac: valve.mac ?? "-" })}</p>
        <Dialog.Footer>
          <Dialog.Close asChild>
            <ActionButton variant="cancel">{m.cancel()}</ActionButton>
          </Dialog.Close>
          <ActionButton variant="primary" rounded onClick={() => mutate()}>
            {m.relaunch_learning_start()} <ArrowRightIcon />
          </ActionButton>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};

RelaunchLearningDialog.displayName = NAME;

export { RelaunchLearningDialog };
export type { RelaunchLearningDialogProps };
